import React, { useContext } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { Footer as SharedFooter } from '@spotify-internal/masthead-react';

import { MastheadFooter } from 'utils/masthead/masthead';
import { MarketContext } from 'providers/market';
import { VerticalContext } from 'providers/vertical';
import { Vertical } from 'utils/vertical';

interface Props {
  data?: MastheadFooter;
}

export const Footer = ({ data }: Props) => {
  const { locale, preferredDir } = useContext(MarketContext);
  const { vertical } = useContext(VerticalContext);

  if (!data) return null;

  const topLinkGroups = cloneDeep(data.topLinkGroups);

  // A custom Contact Us link is added for the en-US market when using the consumer vertical
  if (vertical === Vertical.CONSUMER && locale === 'en-US' && topLinkGroups.length) {
    topLinkGroups[topLinkGroups.length - 1].links.push({
      title: 'Contact Spotify',
      href: 'https://support.spotify.com/article/contact-us/?in_footer',
    });
  }

  return (
    <div dir={preferredDir}>
      <SharedFooter {...data} topLinkGroups={topLinkGroups} />
    </div>
  );
};
